import React, { useContext, useEffect, useState } from 'react';
import { useTitle } from '../../configurations/utils/Utils';
import { useDispatch } from 'react-redux';
import { loginUserClient, logOutUser } from '../../configurations/features/authSliceUser';
import { toastClick } from '../../composants/toast/CustomToast';
import { LoadingContext } from '../../composants/loadingContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../composants/loader/Loader';
import AnimatedText from '../animationText/AnimatedText';
import axiosInstance from '../../configurations/axiosInstance/AxiosInstance';

import CarouselTemplate from '../animationText/CarouselTemplate';


const Login = () => {

    const [showPassword, setShowPassword] = useState(false);
    const {loading, setLoading} = useContext(LoadingContext);
    useTitle("Login");
    const [slides, setSlides] = useState([]);
    const dispatch = useDispatch();
    const [login, setLogin] = useState(
        {
            login: '',
            password: ''
        }
    );
    const [active, setActive] = useState(
        {
            login: false,
            password: false
        }
    );

    const checkPassWordValue = (event) => {
        let pwd = event.target.value.toString().trim();
        if (pwd.length < 3) {
            document.getElementById('pwd').style.border= '1px solid #f20c0c';
            active.password=false;
        } else {
            login.password = pwd;
            setLogin(login);
            document.getElementById('pwd').style.border= '1px solid green';
            active.password=true;
        }
        setActive(active)
    }

    const checkLoginValue = (event) => {
        let loginName = event.target.value.toString().trim();
        if (loginName.length < 3) {
            document.getElementById('login').style.border= '1px solid #f20c0c';
            active.login=false;
        } else {
            login.login = loginName;
            setLogin(login);
            document.getElementById('login').style.border= '1px solid green';
            active.login=true;
        }
        setActive(active)
    }

    const submitRegisterForm = (event) => {
        event.preventDefault();
        setLoading(true);
        if (Object.values(active).every(value => value)) {
            dispatch(loginUserClient(login.login.trim(), login.password.trim(), setLoading));
        } else {
            toastClick("Champs vide","info");
            setLoading(false);
        }
    };

    useEffect(
        ()=>{
            setLoading(false);
            dispatch(logOutUser());
            fetchSlide();
        },[]
    );
    
    const fetchSlide = async () => {
        const slidesInit = []; // Clear default slides
        try {
            const response = await axiosInstance().get('public/api/sliders/by/front/ELEARNING');
            const data = response.data;
            if (data != null) {
              for (let i = 0; i < data.length; i++) {
                const element = data[i];
                slidesInit.push(
                  {
                    id: element.id,
                    cover: element.photo,
                    image: null,
                    title: element.title,
                    subtitle: element.message
                  }
                );
              }
              setSlides(slidesInit);
            } else {
              setSlides(slidesInit);
            }
        } catch (error) {
            setSlides(slidesInit);
        }
    };
    

    

    return (
        <>
            {
                loading && <Loader />

            }
            <div className="min-h-screen flex flex-col md:flex-row">
                <div 
                    className="w-full md:w-1/2 p-8 flex flex-col justify-center items-center relative"
                    style={{
                        backgroundImage: 'url(/images/pngegg.png)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    {/* Overlay blanc avec opacité */}
                    <div className="absolute inset-0 bg-white opacity-40"></div>
                    
                    {/* Contenu par-dessus l'overlay */}
                    <div className="relative z-10 w-full flex flex-col items-center">
                        <div className="text-center">
                            <h1 className="text-2xl font-bold text-gray-900">
                                YOUTHFP e-learning
                            </h1>        
                        </div>
                        <div className="w-full max-w-md">                    
                            <div className="text-center mb-8">
                                <h4 className="text-2xl font-bold text-gray-900 mb-2">
                                    Connexion
                                </h4>
                            </div>

                            <form className="space-y-4" onSubmit={submitRegisterForm}>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Login
                                </label>
                                <input
                                    id="login"
                                    onKeyUp={checkLoginValue}
                                    type="text"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                    placeholder="Entrez votre Login"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Mot de Passe
                                </label>
                                <div className="relative">
                                    <input
                                    id="pwd"
                                    onKeyUp={checkPassWordValue} 
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                                    placeholder="Entrez votre Mot de Passe"
                                    type={showPassword ? "text" : "password"}
                                    required={true}
                                    autoComplete={""}
                                    />
                                    <button
                                    type="button"
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
                                    onClick={() => setShowPassword(!showPassword)}
                                    >
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </button>
                                </div>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-purple-600 text-white py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors"
                            >
                                Continuer
                            </button>

                            <div className="relative">
                                <div className="absolute inset-0 flex items-center">
                                    <div className="w-full border-t border-gray-300"></div>
                                </div>
                                <div className="relative flex justify-center text-sm">
                                    <span className="px-2 bg-white text-gray-500"></span>
                                </div>
                            </div>
                        </form>
                    </div>
                    </div>
                </div>
                {slides.length === 0 ? <div className="hidden md:flex w-1/2 bg-[#7451EB] p-8 items-center justify-center relative" >
                    <AnimatedText /></div> : <div className="hidden md:flex w-1/2 items-center justify-center relative" ><CarouselTemplate sliders={slides} message='' /></div>}
            </div>
        </>
    );
};

export default Login;